import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import esmDropzone from 'dropzone/dist/dropzone';

const { Dropzone } = typeof require === 'function' ? require('dropzone/dist/dropzone') : esmDropzone;

@Component({
  selector: 'cc-file-upload-dropzone',
  templateUrl: './file-upload-dropzone.component.html',
  styleUrls: ['./file-upload-dropzone.component.scss'],
  standalone: true,
  encapsulation: ViewEncapsulation.None,
})
export class FileUploadDropzoneComponent {
  @Input() params = {};
  @Input() uploadTrigger: HTMLElement = null;
  @Input() maxFiles: number;
  @Input() acceptedFiles: string;
  @Input() maxFilesErrorMessage: string;
  @Output() addedfile = new EventEmitter();
  @Output() drop = new EventEmitter();
  @Output() success = new EventEmitter();
  @Output() processing = new EventEmitter();
  @Output() reset = new EventEmitter();
  @Output() error = new EventEmitter();
  @ViewChild('chooseFiles') chooseFiles: ElementRef;
  @ViewChild('droppableArea') droppableArea: ElementRef;
  dropzone: esmDropzone.Dropzone;
  fileSelected = false;
  maxFilesReached = false;

  ngOnInit() {}

  ngAfterViewInit() {
    this.setupDropzone();
  }

  setupDropzone() {
    const defaultParams = {
      url: '/',
      maxFilesize: 100,
      maxFiles: this.maxFiles,
      acceptedFiles: this.acceptedFiles,
      addRemoveLinks: false,
      autoQueue: false,
      clickable: [this.chooseFiles.nativeElement, this.droppableArea.nativeElement],
    };
    this.dropzone = new Dropzone('.dropzone-area', {
      ...defaultParams,
      ...this.params,
    });

    this.dropzone.on('addedfile', (file) => {
      this.maxFilesReached = this.dropzone.files.length >= this.dropzone.options.maxFiles;
      if (this.dropzone.files.length > this.dropzone.options.maxFiles) {
        this.dropzone.removeFile(file);
      }
      this.fileSelected = true;
      this.addedfile.emit(file);
    });

    this.dropzone.on('drop', (file) => {
      this.drop.emit(file);
    });

    this.dropzone.on('success', (file) => {
      this.success.emit(file);
    });
    this.dropzone.on('processing', (file) => {
      this.processing.emit(file);
    });

    this.dropzone.on('reset', (file) => {
      this.reset.emit(file);
    });

    this.dropzone.on('error', (file, message) => {
      this.error.emit({ file, message });
    });

    if (this.uploadTrigger) {
      this.uploadTrigger.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.dropzone.processQueue();
      });
    }
  }
}
